// Write your code here
import {AiFillCalendar} from 'react-icons/ai'
import './index.css'

const ProjectTimelineCard = props => {
  const {projectDetails} = props
  const {
    projectTitle,
    imageUrl,
    duration,
    description,
    projectUrl,
  } = projectDetails
  console.log(projectDetails)

  const visitProjectPage = () => {
    window.open(projectUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <div>
      <img src={imageUrl} alt="project" className="img-project" />
      <div className="title-subs">
        <h1>{projectTitle}</h1>
        <div className="calander-duration">
          <AiFillCalendar />
          <p>{duration}</p>
        </div>
      </div>
      <p>{description}</p>
      <a
        href={projectUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="visit"
      >
        Visit
      </a>
    </div>
  )
}

export default ProjectTimelineCard
